import React, {Fragment, useEffect, useState} from "react";
import getListingSettings from "../utils/getListingSettings";
import client from "../utils/client";

import TAGS from "../queries/tags";
import Listing from "./Listing";
import {getFav} from "../../components/favourites";
import LISTINGS_BY_IDS from "../queries/listingsById";

const FavouritesPage = (props) => {

    const {configs} = props;
    const settings = getListingSettings();

    const [loading, setLoading] = useState(true);
    const [tags, setTags] = useState([]);
    const [listings, setListings] = useState([]);
    const [filterTag, setFilterTag] = useState(undefined);

    useEffect(() => {
        if (settings.tags && settings.tags.length) {
            loadTags();
        }
        loadListings();
    }, []);

    useEffect(() => {
        loadListings();
    }, [filterTag]);

    const loadTags = () => {
        client.query({
            query: TAGS,
            variables: {
                ids: settings.tags
            }
        }).then(({data}) => {
            setTags(data.tags);
        });
    }

    const filterListings = (tag) => {
        setListings([]);
        if (filterTag !== tag) {
            setFilterTag(tag);
        } else {
            setFilterTag(undefined);
        }
    }

    const loadListings = () => {
        setLoading(true);
        const ids = getFav();

        client.query({
            query: LISTINGS_BY_IDS,
            variables: {
                ids: ids.length ? ids : [-1],
                tags: filterTag ? [filterTag] : []
            }
        }).then(({data}) => {
            const ls = data.listingsById;
            setListings([...listings, ...ls]);
            setLoading(false);
        });
    }

    return <div className="container">
        <div className="listing-index">

            {tags.length > 0 && <Fragment>
                <div className="listing-index__mobile-filters dropdown">
                    <select value={filterTag} onChange={(e) => {
                        filterListings(e.target.value)
                    }}>
                        <option value={''}>Filter Tags</option>
                        {tags.map((tag) => {
                            return <option key={tag.Identifier} value={tag.Identifier}>{tag.Title}</option>
                        })}
                    </select>
                </div>
                <div className="listing-index__filters">
                    <h2>Filter Tags:</h2>
                    <div>
                        <ul>
                            {tags.map((tag) => {
                                return <li key={tag.Identifier}>
                                    <a href="#"
                                       className={tag.Identifier === filterTag ? "btn btn--solid btn--solid--liteGray active" : "btn btn--solid btn--solid--liteGray"}
                                       onClick={(e) => {
                                           e.preventDefault();
                                           filterListings(tag.Identifier)
                                           return false;
                                       }}>{tag.Title}</a>
                                </li>
                            })}
                        </ul>
                    </div>
                </div>
            </Fragment>}

            {!!loading && <div className="listing-index__loading">Loading</div>}

            {listings.length > 0 && <div className="listing-index__grid">
                {listings.map((listing, index) => {
                    return <Listing
                        key={index}
                        listing={listing}
                        index={index}
                        categoryMap={configs}
                        urlBase={settings.link}
                        displayFeatures={false}
                        nofFeaturedListings={0}
                        defaultBlank={true}
                    />
                })}
            </div>}
        </div>
    </div>

}

export default FavouritesPage;
